var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-jumbotron',{staticClass:"mt-4",attrs:{"lead":_vm.lead}},[_c('template',{slot:"header"},[_c('h3',[_vm._v(_vm._s(_vm.header))])]),_c('router-link',{attrs:{"to":{ name: 'profile'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_vm._v("Go to my Profile")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }